module.exports = __webpack_public_path__ + "static/media/gr.90595896.svg";